import imageCompression from "browser-image-compression";

function getOutputFileInfo(file: File, customFileName?: string) {
  const isPng = file.type === "image/png";
  // Keep png format to preserve transparency
  const fileType = isPng ? "image/png" : "image/jpeg";
  const ext = isPng ? ".png" : ".jpg";
  const fileName = (customFileName || file.name).replace(/\.[^/.]+$/, "") + ext;

  return { fileType, fileName };
}

export async function compressImage(file: File, customFileName?: string): Promise<File> {
  const options = {
    maxWidthOrHeight: 2048,
    initialQuality: 0.85,
    useWebWorker: true,
  };

  const { fileType, fileName } = getOutputFileInfo(file, customFileName);

  try {
    const compressedBlob = await imageCompression(file, {
      ...options,
      fileType,
    });
    return new File([compressedBlob], fileName, {
      type: fileType,
      lastModified: Date.now(),
    });
  } catch (err) {
    const isNotImage = err instanceof Error && err.message.includes("not an image");
    if (!isNotImage) {
      console.warn(`Failed to compress ${file.name}, using original.`, err);
    }
    return file;
  }
}
